export default __webpack_public_path__ + "static/media/pattern-random2.28c8997c.jpg";